export const getSharePresentationDetails = `
query getSharePresentationDetails($shareUUID: String!) {
  getSharePresentationDetails(shareUUID: $shareUUID) {
    id
    name
    description
    presentationId
    url
    page
    script
    shortScript
    language
    volume
    playOrder
    scriptAudio
    scriptAudioName
    animation
    cycleanimation
    mute
    videoDuration
    videoStartTime
    videoEndTime
    presentation{
      id
      name
      languageConfig
      backgroundMusic
      backgroundVolume
      keywords
      title
      contactEmail
      contactPhone
      callToActionEnable
      userInfoEnable
      recommendVideoEnable
      recommendVideoType
      callToActionType
      callToActionTableConfig
      callToActionLinkConfig
      userInfoConfig
      blogBrief
      blogBriefAnimation
      playCount
      impressionCount
      createdAt
      user {
        id
        name
        avatarUrl
      }
      autoPlaySlideInterval
    }
    presentationDetailScriptTranslation{
      language
      translationScript
    }
    presentationDetailVideoScript{
      id
      seq
      textSTT
      textGPT
      start
      presentationDetailVideoScriptTranslation{
        id
        language
        translationText
      }
    }
  }
}
`;

export const updatePresentationStatistics = `
mutation updatePresentationStatistics($presentationId: Int!,$type:String!) {
 updatePresentationStatistics(presentationId: $presentationId,type:$type) 
}
`;
export const createPlayDetailRecord = `
  mutation createPlayDetailRecord($playDetailRecord: PlayDetailRecordInput!) {
    createPlayDetailRecord(playDetailRecord: $playDetailRecord) {
      id
    }
  }
`;

export const updatePlayDetailRecord = `
  mutation updatePlayDetailRecord($playDetailRecord: PlayDetailRecordUpdateInput! ,$id: Int!) {
    updatePlayDetailRecord(playDetailRecord: $playDetailRecord,id:$id) {
      id
    }
  }
`;
export const getPresentationBlogByPlayer = `
mutation getPresentationBlogByPlayer($blogId: Int!,$blogUrl:String!, $type: String!) {
  getPresentationBlogByPlayer(blogId: $blogId,blogUrl:$blogUrl, type: $type) {
    id
    blogId
    blogUrl
    blogTitle
    blogImg
    blogContent
    blogBrief
    blogBriefAnimation
    imps
    views
    backgroundMusic
    languageConfig
    volume
    tags  
    presentationBlogContent{
      id
      content
      url
      img
      offsetTop
      presentationBlogContentTranslation{
          language
          translationContent
          presentationBlogId
          presentationBlogContentId
      }
      animation
      cycleanimation
    }
  }
}
`;

export const getPresentationBlog = `
mutation getPresentationBlog($type: String!,$id:Int!) {
  getPresentationBlog(type: $type,id:$id) {
    id
    blogId
    blogUrl
    blogTitle
    blogImg
    blogContent
    imps
    views
    backgroundMusic
    languageConfig
    volume
    tags
  }
}
`;

export const getIssue = `
query getIssue($id: Int!) {
  getIssueWithUsersAndComments(issueId: $id) {
    id
    title
    description
    attachments{
      id
      name
      url
    }
  }
}
`
export const createPresentationContact = `
  mutation createPresentationContact(
    $presentationContact: PresentationContactInput!
  ) {
    createPresentationContact(presentationContact: $presentationContact) {
      id
      name
      email
    }
  }
`;

export const getPresentationReferVideos = `
query  getPresentationReferVideos($presentationId: Int!) {
        getPresentationReferVideos(presentationId: $presentationId) {
            id
            createdAt
            updatedAt
            presentationId
            presentationReferVideoId
            presentationReferVideo {
                id
                name
                title
                shareUUID
                presentationDetail {
                    id
                    name
                    description
                    url
                    page
                }
            }
        }
    }
`
